<script setup>
const props = defineProps({
  location: Array,
  time: Array,
  level: Array,
  detail: Object,
  date: String,
  slug: String,
  activeIndex: Number,
  index: Number,
  loading: Boolean,
})
const route = useRoute()
const router = useRouter()
const { t } = useI18n()

function filteredRoute() {
  const category = props.slug
  const result = category.replace(/th\/+/, '')
  return `/${result}`
}

function filteredJobLocation() {
  for (let i = 0; i < props.location.length; i++) {
    const item = props.location[i]
    if (item.uuid === props.detail.job_location)
      return item.value
  }
}

function filteredJobTime() {
  for (let i = 0; i < props.time.length; i++) {
    const item = props.time[i]
    if (item.uuid === props.detail.job_time)
      return item.value
  }
}

function filteredJobLevel() {
  for (let i = 0; i < props.level.length; i++) {
    const item = props.level[i]
    if (item.uuid === props.detail.job_level)
      return item.value
  }
}
</script>

<template>
  <li v-if="loading" class="md:justify-normal relative z-10 w-full flex flex-col cursor-pointer justify-center rounded-lg bg-white p-5 shadow-custom-xl transition duration-200 ease-linear md:flex-row md:items-center">
    <UISpinner class="mx-auto min-h-[135px]" />
  </li>
  <li
    v-else
  >
    <NuxtLink
      class="md:justify-normal linear relative z-10 w-full flex flex-col cursor-pointer justify-center rounded-lg bg-white p-5 shadow-custom-xl transition-all duration-500 md:flex-row md:items-center"
      :class="props.activeIndex === props.index ? 'border-l-4 border-secondary-red-100 !scale-[102%]' : 'border-l-4 border-secondary-gray-100 !scale-100'"
      :to="localePath({ path: filteredRoute() })"
      target="_blank"
    >
      <div
        class="w-full flex flex-wrap md:flex-nowrap"
      >
        <div class="w-full">
          <h3 class="mb-4 text-lg text-primary font-semibold lg:text-2xl md:text-xl">
            {{ detail.title }}
          </h3>
          <div class="flex flex-wrap gap-3">
            <div
              class="flex flex-row items-center justify-center gap-x-1 rounded-full bg-slate-100 px-3 py-1"
            >
              <svg class="text-slate-600" width="18" height="18" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12 12q.825 0 1.413-.588T14 10q0-.825-.588-1.413T12 8q-.825 0-1.413.588T10 10q0 .825.588 1.413T12 12Zm0 7.35q3.05-2.8 4.525-5.088T18 10.2q0-2.725-1.738-4.462T12 4Q9.475 4 7.737 5.738T6 10.2q0 1.775 1.475 4.063T12 19.35ZM12 22q-4.025-3.425-6.012-6.362T4 10.2q0-3.75 2.413-5.975T12 2q3.175 0 5.588 2.225T20 10.2q0 2.5-1.988 5.438T12 22Zm0-11.8Z"
                />
              </svg>
              <span v-if="detail.job_location" class="text-sm text-slate-600 font-semibold capitalize">{{ filteredJobLocation() }}</span>
            </div>
            <div
              class="flex flex-row items-center justify-center gap-x-1 rounded-full bg-slate-100 px-3 py-1"
            >
              <svg class="text-slate-600" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7z" /></svg>
              <span v-if="detail.job_time" class="text-sm text-slate-600 font-semibold capitalize">{{ filteredJobTime() }}</span>
            </div>
            <div
              class="flex flex-row items-center justify-center gap-x-1 rounded-full bg-slate-100 px-3 py-1"
            >
              <svg class="text-slate-600" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M14 6V4h-4v2h4zM4 8v11h16V8H4zm18-2v15H2.01V6H8V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2h6z" /></svg>
              <span v-if="detail.job_level" class="text-sm text-slate-600 font-semibold capitalize">{{ filteredJobLevel() }}</span>
            </div>
          </div>
        </div>
        <div class="mt-custom-lg flex flex-wrap items-center gap-4 md:ml-auto md:mt-0 sm:flex-nowrap">
          <UIButton type="text" class="whitespace-nowrap rounded-md">
            <span>{{ t('button.apply') }}</span>
          </UIButton>
        </div>
      </div>
    </NuxtLink>
  </li>
</template>
